import { ShieldCheck, Boxes, Zap, CalendarRange, BadgePercent } from "lucide-react";
import Reveal, { Stagger, RevealItem } from "@/components/site/Reveal";

const items = [
  { icon: ShieldCheck, title: "Maquinaria revisada", desc: "Cada equipo pasa control técnico antes de salir." },
  { icon: Boxes, title: "Gran variedad", desc: "Construcción, jardinería e industria en un único lugar." },
  { icon: Zap, title: "Atención rápida", desc: "Te respondemos en minutos y entregamos el mismo día." },
  { icon: CalendarRange, title: "Alquiler flexible", desc: "Por día, semana o mes. Tú eliges el plazo." },
  { icon: BadgePercent, title: "Precios competitivos", desc: "Tarifas claras, sin sorpresas ni costes ocultos." },
];

export default function Features() {
  return (
    <section data-testid="features-section" className="py-24 md:py-28 bg-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-sky-600">
              <span className="w-6 h-px bg-sky-500" /> Por qué elegirnos
            </span>
            <h2 className="font-heading mt-4 text-3xl md:text-4xl font-bold tracking-tight text-slate-950 leading-[1.1]">
              Trabajamos para que tu obra no se detenga
            </h2>
            <p className="mt-5 text-slate-600 text-base md:text-lg leading-relaxed">
              Maquinaria fiable, condiciones honestas y un equipo que entiende la urgencia del sector.
            </p>
          </div>
        </Reveal>

        <Stagger className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <RevealItem key={it.title}>
                <div
                  data-testid={`feature-card-${i}`}
                  className="group relative h-full bg-white rounded-2xl border border-slate-200 p-6 hover:border-sky-300 hover:shadow-[0_18px_48px_-18px_rgba(14,165,233,0.35)] hover:-translate-y-1.5 transition-all duration-300"
                >
                  <div className="w-12 h-12 rounded-xl bg-slate-950 text-sky-400 flex items-center justify-center transition-all duration-300 group-hover:bg-sky-500 group-hover:text-white group-hover:scale-110 group-hover:rotate-3 shadow-sm">
                    <Icon className="w-6 h-6" strokeWidth={2} />
                  </div>
                  <h3 className="font-heading mt-5 font-bold text-slate-950 text-base lg:text-lg">
                    {it.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{it.desc}</p>
                  <span aria-hidden className="absolute inset-x-6 bottom-3 h-px bg-gradient-to-r from-sky-500/0 via-sky-500/40 to-sky-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
              </RevealItem>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
}
